import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import {
VideoLessonUploadForm
} from "../../../Pages/VideoLessons/Ivideolessons";

// Construct the IVideoUpload type using existing interfaces
type IVideoUpload = VideoLessonUploadForm;

const initialState: IReduxState<IVideoUpload> = {
  data: {} as IVideoUpload,
  isLoading: false,
};

export const EditVideoUploadSlice = createSlice({
  name: "EditVideoUploadSlice",
  initialState,
  reducers: {
    editVideoUpload: (state, _: PayloadAction<VideoLessonUploadForm>) => {
      console.log(state,"state received")
      state.isLoading = true;
    },
    successEditVideoUpload: (state, action: PayloadAction<IVideoUpload>) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureEditVideoUpload: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearEditVideoUploadResponse: (state) => {
      state.data = {} as IVideoUpload;
    },
  },
});

export const {
  editVideoUpload,
  successEditVideoUpload,
  failureEditVideoUpload,
  clearEditVideoUploadResponse,
} = EditVideoUploadSlice.actions;

export default EditVideoUploadSlice.reducer;
